var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 798,
    height: 548,
    viewBox: "0 0 798 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9092,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9092,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#AB98D8"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AB98D8"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#AB98D8"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AB98D8"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#AB98D8"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B3A0E2"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B3A0E2"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A99AE2"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#AA82D8"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#A885DF"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#BECEE5"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A191DC"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#B197D2"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#A98CDC"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#DDAFEF"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9092,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 722.364,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 722.364,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 747.272,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 722.364,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9092,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#EAC144"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 747.272,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#A48122"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#CC9BC5"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#A98CDC"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#A98CDC"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 99.6365,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 74.7273,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 24.9092,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 49.8181,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    fill: "#D0A6CA"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8184,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6362,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7271,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 124.545,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 199.273,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 523.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 498.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 473.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 448.364,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 423.455,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 149.455,
    y: 398.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 174.364,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 224.182,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 373.636,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 249.091,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 398.545,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 523.091,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 622.728,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 298.909,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 423.455,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 722.364,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 323.818,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 448.364,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 572.909,
    y: 298.909,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 722.364,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 697.455,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 747.272,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 797.091,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 797.091 174.364)",
    fill: "black"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 772.182,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 772.182 149.455)",
    fill: "black"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 124.545,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 647.636 124.545)",
    fill: "black"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 647.636,
    y: 149.455,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 647.636 149.455)",
    fill: "black"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 174.364,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 672.545 174.364)",
    fill: "black"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 797.091,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    transform: "rotate(90 797.091 199.273)",
    fill: "black"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 597.818,
    y: 224.182,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 672.545,
    y: 199.273,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 373.636,
    y: 348.727,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 348.727,
    y: 274,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 473.273,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 498.182,
    y: 249.091,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    y: 323.818,
    width: 24.9091,
    height: 24.9091,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtGlobe);
export default __webpack_public_path__ + "static/media/pixel-art-globe.5ca31b2f330e91552dbb6bfb95baa966.svg";
export { ForwardRef as ReactComponent };